'use client'

import useEnquiry from '@hooks/useEnquiry'
import classNames from 'classnames'

export default function OfficeEmailButton({
  data,
  className,
  icon = false,
  full = true,
  children
}) {

  const { showOfficeEnquiry } = useEnquiry()
  return data.email && (
    <button
      type='button'
      className={classNames('button-orange', { 'w-full': full }, { 'px-20 justify-between': icon }, className)}
      onClick={showOfficeEnquiry({ office: data, signupSource: 'agent_appraisal' })}
    >
      {icon && <i className='icon icon-email'></i>}
      <span className={classNames({ 'flex-1 text-center': icon })}>{children || 'Get an appraisal'}</span>
    </button>
  )
}